import type {
  BreakdownSingleDataSet,
  SingleDataSet,
} from '../DataProvider/types';
import type { MetricValues } from '../PageConfigProvider/types/metric';
import { NestedTreeMap } from './NestedTreeMap';

type TreeMapProps = {
  data: BreakdownSingleDataSet | SingleDataSet;
  metric?: MetricValues;
};

/**
 * Treemap entry point used by the chart selector.
 *
 * The nested treemap: grouped rectangles, drilldown that fetches its initial
 * level through {@link NestedCompositionTreemapDrilldownProvider}, and the
 * extra parent-totals composition query.
 */
export const TreeMap = ({ data, metric }: TreeMapProps) => {
  return <NestedTreeMap data={data} metric={metric} />;
};
